export enum TagType {
  NeedResolution = 'NeedResolution',
  Rotation = 'Rotation',
  OilChange = 'OilChange',
  Colab = 'Colab',
  Lsa = 'Lsa',
  Social = 'Social',
  Website = 'Website',
  Lavin = 'Lavin',
  CrGiftCard = 'CrGiftCard'
}

export const TagTypeToLabel: { [key: string]: string } = {
  NeedResolution: 'Need resolution',
  Rotation: 'Rotation',
  OilChange: 'Oil change',
  Colab: 'Colab Lead',
  Lsa: 'LSA Lead',
  Social: 'Social Lead',
  Website: 'Website Lead',
  Lavin: 'Lavin Lead',
  CrGiftCard: 'CR Gift Card'
}
